export const ModalSidePanelLayout = "ModalSidePanelLayout";
export const ModalSidePanelLayout__LeftPanel = `${ModalSidePanelLayout}__LeftPanel`;
export const ModalSidePanelLayout__RightPanel = `${ModalSidePanelLayout}__RightPanel`;
